import { useEffect } from 'react';
import { marketDataRuntime } from '../../data/client/marketDataRuntime';
import { useQuote } from '../../data/stores/quoteStore';
import type { QuoteWindowConfig, WindowConfig, WindowInstance } from '../../workspace/types';
import { formatNumber, formatSigned } from '../../shared/format';

interface QuoteWindowProps {
  window: WindowInstance<QuoteWindowConfig>;
  onConfigChange: (updater: (config: WindowConfig) => WindowConfig) => void;
  onOpenGraph: (symbol: string) => void;
}

const QUOTE_TILE_FIELDS = ['symbol', 'last', 'change', 'changePct', 'time'] as const;

export function QuoteWindow({ window, onOpenGraph }: QuoteWindowProps) {
  const quote = useQuote(window.config.symbol);
  const tone = quote.change >= 0 ? 'positive' : 'negative';

  useEffect(() => {
    return marketDataRuntime.subscribeQuotes(
      window.id,
      [window.config.symbol],
      [...QUOTE_TILE_FIELDS]
    );
  }, [window.id, window.config.symbol]);

  return (
    <div
      className={`quote-tile-window quote-tile-window--${tone} no-window-drag`}
      onDoubleClick={() => onOpenGraph(window.config.symbol)}
    >
      <button
        className="quote-tile"
        onClick={() => onOpenGraph(window.config.symbol)}
        title={`Open ${window.config.symbol} graph`}
      >
        <span className="quote-tile__symbol">{window.config.symbol}</span>

        <span className="quote-tile__details">
          <span className="quote-tile__price">${formatNumber(quote.last)}</span>

          <span className="quote-tile__change">
            <span>{formatSigned(quote.changePct)}%</span>
            <span>{formatSigned(quote.change)}</span>
          </span>
        </span>
      </button>
    </div>
  );
}